import * as React from "react";
import StoreCard from "../store-card";
export default class StoreList extends React.Component {
    constructor(props) {
        super(props);
        this.getGeoLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(this.props.getLocation);
            }
        };
        this.addressKeyPress = (event) => {
            if (event.key == 'Enter') {
                this.props.updateAddressText(event.target.value);
            }
        };
    }
    render() {
        const stores = this.props.stores.map((store, index) => {
            return React.createElement(StoreCard, { store: store, key: index, selected: this.props.selected === index.toString(), storeIndex: store.storeIndex, updateSelected: this.props.updateSelected, MarkerClick: this.props.MarkerClick });
        });
        return (React.createElement("div", { className: "store-list" },
            React.createElement("div", { className: "store-filter" },
                React.createElement("div", { className: "location-container" }, navigator.geolocation ? (React.createElement("span", null,
                    React.createElement("i", { className: "fa fa-location-arrow store-location", onClick: this.getGeoLocation }),
                    React.createElement("span", null, "Get Location"))) : null),
                React.createElement("div", { className: "search-results-bar postal-code-bar" },
                    React.createElement("input", { placeholder: "Enter Address, Postal Code, or Landmark", onKeyPress: this.addressKeyPress, onBlur: (e) => { this.props.updateAddressText(e.target.value); } }),
                    React.createElement("i", { className: "fa fa-search" }))),
            stores));
    }
}
;
//# sourceMappingURL=store-list.js.map